export default __webpack_public_path__ + "static/media/header-bg.cdb88dac.jpg";